import PropTypes from "prop-types";
import React ,{useState} from "react";
import { Button, Conainer, Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form , Spinner} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import {resetPassword} from 'aws-amplify/auth'

// action
import { userForgetPassword } from "../../slices/thunks";

import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";
import AuthSlider from '../AuthenticationInner/authCarousel';
import { toast } from "react-toastify";
const ForgetPasswordPage = props => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: async(values) => {
      setLoading(true);
      try {
        const {nextStep} = await resetPassword({email:values.email ,username:values.email});
        switch (nextStep.resetPasswordStep) {
          case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
            const codeDeliveryDetails = nextStep.codeDeliveryDetails;
            props.router.navigate("/confirm-reset-password", { state: { username: values.email}, });
            console.log(
              `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
            );
            // Collect the confirmation code from the user and pass to confirmResetPassword.
            break;
        }
      } catch (error) {
        // console.log(`Error message ${error.message}`);
        
      }
      setLoading(false);
      
    }
  });
  const selectLayoutState = (state) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (state) => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
    })
  );
  // Inside your component
  const {
    forgetError, forgetSuccessMsg
  } = useSelector(selectLayoutProperties);


document.title="Media Pulse | Reset Password ";

  return (
    <React.Fragment>
        <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
            <div className="bg-overlay"></div>
            <div className="auth-page-content overflow-hidden pt-lg-5">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <Card className="overflow-hidden">
                                <Row className="justify-content-center g-0">
                                    <AuthSlider />

                                    <Col lg={6}>
                                        <div className="p-lg-5 p-4">
                                            <h5 className="text-primary">Forgot Password?</h5>
                                            <p className="text-muted">A verification code will be sent to the email address you provide</p>

                                            <div className="mt-2 text-center">
                                                <lord-icon
                                                    src="https://cdn.lordicon.com/rhvddzym.json"
                                                    trigger="loop"
                                                    colors="primary:#0ab39c"
                                                    className="avatar-xl"
                                                    style={{ width: "120px", height: "120px" }}>
                                                </lord-icon>
                                            </div>

                                            <div className="alert border-0 alert-warning text-center mb-2 mx-2" role="alert">
                                                Enter your email and instructions will be sent to you!
                                            </div>
                                            <div className="p-2">
                                                <Form onSubmit={validation.handleSubmit}>
                                                    <div className="mb-4">
                                                        <Label className="form-label">Email</Label>
                                                        <Input
                                                            type="email"
                                                            className="form-control"
                                                            id="email"
                                                            placeholder="Enter email address"
                                                            name="email"
                                                            value={validation.values.email}
                                                            onBlur={validation.handleBlur}
                                                            onChange={validation.handleChange}
                                                            invalid={validation.errors.email && validation.touched.email ? true : false}
                                                        />
                                                        {validation.errors.email && validation.touched.email ? (
                                                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                        ) : null}
                                                    </div>

                                                    <div className="text-center mt-4">
                                                        <Button color="success" disabled={loading} className="w-100" type="submit">
                                                        {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> :"Send Reset Code"}</Button>
                                                    </div>
                                                </Form>
                                            </div>

                                            <div className="mt-5 text-center">
                                                <p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-bold text-primary text-decoration-underline"> Click here </Link> </p>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <footer className="footer">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center">
                                <p className="mb-0">&copy; {new Date().getFullYear()} Whistlemind Technologies LLP. Crafted with <i className="mdi mdi-heart text-danger"></i> </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>
    </React.Fragment>
);
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
